export default __webpack_public_path__ + "static/media/thirdOne.50168520.png";